import styled from 'styled-components';

import { TextButton as TextButtonComponent } from '@xing-com/button';
import { space4XL } from '@xing-com/tokens';

export const TextButton = styled(TextButtonComponent)`
  margin-top: ${space4XL};
`;
